import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt23 } from './phonics/phonics_data_lt23';

function PhonicsLt23() {
  return <PhonicsLt letterData={letterDataLt23} />;
}

export default PhonicsLt23;
